module.exports = __webpack_public_path__ + "img/zoom-in_bg-blue.6487851e.svg";